import React from "react";
import { Button, Collapse, Tag } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

interface IdListSectionProps {
	title: string;
	ids: number[];
	tone: "success" | "info" | "warning";
	copyLabel: string;
	copiedMessage: string;
}

const TONE_COLORS: Record<IdListSectionProps["tone"], string> = {
	success: "green",
	info: "blue",
	warning: "orange",
};

const IdListSection = ({
	title,
	ids,
	tone,
	copyLabel,
	copiedMessage,
}: IdListSectionProps) => {
	if (ids.length === 0) {
		return null;
	}

	const handleCopy = (e: React.MouseEvent) => {
		e.stopPropagation();
		navigator.clipboard.writeText(ids.join("\n"));
		toast.success(copiedMessage);
	};

	return (
		<Collapse
			className="mb-2"
			// Warning-tone lists (already paid, not found, ineligible) are what the
			// operator must notice — open them by default.
			defaultActiveKey={tone === "warning" ? ["ids"] : []}
			items={[
				{
					key: "ids",
					label: (
						<span className="flex items-center gap-2 flex-wrap">
							<span>{title}</span>
							<Tag color={TONE_COLORS[tone]}>{ids.length}</Tag>
							<Button
								size="small"
								icon={<CopyOutlined />}
								onClick={handleCopy}
							>
								{copyLabel}
							</Button>
						</span>
					),
					children: (
						// Plain joined text — Tags per id would be heavy at up to 5000 entries.
						<div className="font-mono text-xs break-all max-h-64 overflow-y-auto">
							{ids.join(", ")}
						</div>
					),
				},
			]}
		/>
	);
};

export default IdListSection;
